import { render, staticRenderFns } from "./POIBulk.vue?vue&type=template&id=1075540e&"
import script from "./POIBulk.vue?vue&type=script&lang=js&"
export * from "./POIBulk.vue?vue&type=script&lang=js&"
import style0 from "./POIBulk.vue?vue&type=style&index=0&id=1075540e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports